module.exports = __webpack_public_path__ + "img/our-story-text.8333e134.svg";